module.exports = __webpack_public_path__ + "img/marker3.f6b69b2b.png";